import { IIconProps } from "@/components/icons/interface";

const EditPencilIcon = ({ width, height, color }: IIconProps) => {
  return (
    <svg
      width={width ?? 20}
      height={height ?? 20}
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="vuesax/linear/edit-2">
        <g id="edit-2">
          <path
            id="Vector"
            d="M10.4975 2.85021L3.9979 9.7298C3.75248 9.99105 3.51498 10.5056 3.46748 10.8619L3.17457 13.4269C3.07165 14.3531 3.73665 14.9865 4.65498 14.8281L7.20415 14.3927C7.5604 14.3294 8.05915 14.0681 8.30457 13.799L14.8042 6.91938C15.9283 5.73188 16.435 4.37813 14.6854 2.72355C12.9437 1.0848 11.6217 1.66271 10.4975 2.85021Z"
            stroke={color || "#292D32"}
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            id="Vector_2"
            d="M9.41406 3.99805C9.75448 6.18305 11.5278 7.85346 13.7286 8.07513"
            stroke={color || "#292D32"}
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            id="Vector_3"
            d="M2.375 17.4165H16.625"
            stroke={color || "#292D32"}
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};

export { EditPencilIcon };
